/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduledDropEnrollmentRow } from './ScheduledDropEnrollmentRow';
import {
    ScheduledDropEnrollmentRowFromJSON,
    ScheduledDropEnrollmentRowFromJSONTyped,
    ScheduledDropEnrollmentRowToJSON,
    ScheduledDropEnrollmentRowToJSONTyped,
} from './ScheduledDropEnrollmentRow';

/**
 * 
 * @export
 * @interface ScheduledDropEnrollmentsWidgetData
 */
export interface ScheduledDropEnrollmentsWidgetData {
    /**
     * 
     * @type {Array<ScheduledDropEnrollmentRow>}
     * @memberof ScheduledDropEnrollmentsWidgetData
     */
    items: Array<ScheduledDropEnrollmentRow>;
}

/**
 * Check if a given object implements the ScheduledDropEnrollmentsWidgetData interface.
 */
export function instanceOfScheduledDropEnrollmentsWidgetData(value: object): value is ScheduledDropEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ScheduledDropEnrollmentsWidgetDataFromJSON(json: any): ScheduledDropEnrollmentsWidgetData {
    return ScheduledDropEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function ScheduledDropEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledDropEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ScheduledDropEnrollmentRowFromJSON)),
    };
}

export function ScheduledDropEnrollmentsWidgetDataToJSON(json: any): ScheduledDropEnrollmentsWidgetData {
    return ScheduledDropEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function ScheduledDropEnrollmentsWidgetDataToJSONTyped(value?: ScheduledDropEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ScheduledDropEnrollmentRowToJSON)),
    };
}

